<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'app',
  computed: {
    ...mapGetters(['user', 'token']),
    ...mapActions(['FETCH_USER']),
    nextRoute() {
      return this.$route.query.redirect || '/'
    },
  },
  beforeCreate() {
    document.documentElement.style.setProperty('--theme-primary-color', this.$store.state.user.user ? this.$store.state.user.user.school ? this.$store.state.user.user.school.color : '' : '')
    document.documentElement.style.setProperty('--theme-primary-font', this.$store.state.user.user ? this.$store.state.user.user.school ? this.$store.state.user.user.school.font : '' : '')
    // if (this.$store.state.user.token && !this.$store.state.user.user) {
    //   this.$store.dispatch('FETCH_USER')
    // }
  },
  beforeMount () {
    let mountscript = document.createElement('script')
    mountscript.setAttribute('src', 'https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image')
    document.head.appendChild(mountscript)
  },
  watch: {
    token(auth) {
      if (auth) {
        this.$router.replace(this.nextRoute)
      }
    },
    '$route'(to, from) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
}
</script>
